import { useMemo, useState } from 'react';

function safeStr(v) {
  return String(v || '').trim();
}

function enc(v) {
  return encodeURIComponent(String(v || ''));
}

function canWebShare() {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}

function canClipboard() {
  return typeof navigator !== 'undefined' && navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
}

function ShareBar({
  url,
  title,
  text,
  label = 'Share',
  compact = true,
  showLabel = true,
}) {
  const shareUrl = safeStr(url);
  const shareTitle = safeStr(title);
  const shareText = safeStr(text);

  const [status, setStatus] = useState('');

  const links = useMemo(() => {
    const u = enc(shareUrl);
    const t = enc(shareTitle || shareText);
    const msg = enc([shareTitle, shareText].filter(Boolean).join(' — '));

    return [
      { key: 'x', label: 'X', href: `https://twitter.com/intent/tweet?url=${u}&text=${t}` },
      { key: 'facebook', label: 'Facebook', href: `https://www.facebook.com/sharer/sharer.php?u=${u}` },
      { key: 'linkedin', label: 'LinkedIn', href: `https://www.linkedin.com/sharing/share-offsite/?url=${u}` },
      { key: 'telegram', label: 'Telegram', href: `https://t.me/share/url?url=${u}&text=${msg}` },
    ];
  }, [shareTitle, shareText, shareUrl]);

  const handleCopy = async () => {
    if (!shareUrl) return;
    if (!canClipboard()) {
      setStatus('Copy is not supported in this browser.');
      return;
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
      setStatus('Link copied.');
      setTimeout(() => setStatus(''), 1600);
    } catch {
      setStatus('Failed to copy link.');
    }
  };

  const handleWebShare = async () => {
    if (!shareUrl || !canWebShare()) return;
    try {
      await navigator.share({
        title: shareTitle || undefined,
        text: shareText || undefined,
        url: shareUrl,
      });
    } catch {
      // user cancelled / not supported; ignore
    }
  };

  if (!shareUrl) return null;

  return (
    <section className={`share-bar ${compact ? 'share-bar-compact' : ''}`.trim()} aria-label={label}>
      <div className="share-bar-row">
        {showLabel && <div className="share-bar-title">{label}</div>}
        <div className="share-bar-actions">
          {canWebShare() && (
            <button type="button" className="header-outline-button share-button" onClick={handleWebShare}>
              Share
            </button>
          )}
          <button type="button" className="header-outline-button share-button" onClick={handleCopy}>
            Copy
          </button>
          {links.map((l) => (
            <a
              key={l.key}
              className="header-outline-button share-link share-button"
              href={l.href}
              target="_blank"
              rel="noopener noreferrer"
              title={`Share on ${l.label}`}
            >
              {l.label}
            </a>
          ))}
        </div>
      </div>
      {status && <div className="secondary-text share-bar-status">{status}</div>}
    </section>
  );
}

export default ShareBar;


